import React from 'react';

export default function ArrowDown() {
  return (
    <svg width="8" height="5" viewBox="0 0 8 5">
      <path d="M1.707.293c-.391-.391-1.024-.391-1.414 0-.391.391-.391 1.024 0 1.414l3 3c.391.391 1.024.391 1.414 0l3-3c.391-.391.391-1.024 0-1.414-.391-.391-1.024-.391-1.414 0l-2.293 2.293-2.293-2.293z" />
    </svg>
  );
}



// WEBPACK FOOTER //
// ./src/components/icons/ArrowDown/index.js